import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import {
  ActiveCrafts,
  ActiveDriver,
  CreateMessage,
  MessagingServiceService,
  Recipients,
} from 'src/app/services/messaging-service.service';

@Component({
  selector: 'app-new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.css'],
})
export class NewMessageComponent implements OnInit {
  regForm: FormGroup;
  SelectedCrafts = new FormControl();
  SelectedDrivers = new FormControl();
  readonly ALL_CRAFTS_VALUE = '__ALL_CRAFTS__';
  readonly ALL_DRIVERS_VALUE = '__ALL_DRIVERS__';
  Crafts: ActiveCrafts[] = [];
  Drivers: ActiveDriver[] = [];

   // Suchbegriffe
  searchCraft: string = '';
  searchDriver: string = '';

  // Gefilterte Listen
  filteredCrafts: ActiveCrafts[] = [];
  filteredDrivers: ActiveDriver[] = [];

  messageText: FormControl;
  sending: boolean = false
  constructor(
    private messagingService: MessagingServiceService,
    formBuilder: FormBuilder,
    private router: Router,
    private snackbar: MatSnackBar
  ) {
    this.regForm = formBuilder.group({
      messageText: this.messageText,
    });
  }

  ngOnInit(): void {
    this.messagingService.getActiveDrivers().subscribe((data) => {
      this.Drivers = data.sort((a, b) => a.fullName.localeCompare(b.fullName));
      this.filteredDrivers = [...this.Drivers];
    });

    this.messagingService.getActiveCrafts().subscribe((data) => {
      this.Crafts = data.sort((a, b) => Number(a.craftNr) - Number(b.craftNr));
      this.filteredCrafts = [...this.Crafts]; 
    });
  }

  filterCrafts() {
    if (!this.searchCraft) {
      this.filteredCrafts = [...this.Crafts];
      return;
    }

    this.filteredCrafts = this.Crafts.filter(craft =>
      craft.craftNr.toString().includes(this.searchCraft)
    );
  }

  onCraftSelectionChange() {
    const selectedValues = this.SelectedCrafts.value || [];
    if (selectedValues.includes(this.ALL_CRAFTS_VALUE)) {
      const selectedCrafts = selectedValues.filter((item: ActiveCrafts | string) => item && typeof item !== 'string');
      const areAllCraftsSelected = this.Crafts.length > 0 && selectedCrafts.length === this.Crafts.length;

      this.SelectedCrafts.setValue(areAllCraftsSelected ? [] : [...this.Crafts], { emitEvent: false });
    }
    this.filterCrafts();
  }

  onCraftPanelToggle(opened: boolean) {
    if (!opened) {
      this.searchCraft = '';
      this.filteredCrafts = [...this.Crafts];
    }
  }

  getSelectedCraftCount(): number {
    const selectedValues = this.SelectedCrafts.value || [];
    return selectedValues.filter((item: ActiveCrafts | string) => item && typeof item !== 'string').length;
  }

  getFirstSelectedCraft(): ActiveCrafts | null {
    return (this.SelectedCrafts.value || []).find((item: any) => item && typeof item !== 'string') || null;
  }

  isAllCraftsSelected(): boolean {
    return this.Crafts.length > 0 && this.getSelectedCraftCount() === this.Crafts.length;
  }

  isCraftsIndeterminate(): boolean {
    const count = this.getSelectedCraftCount();
    return count > 0 && count < this.Crafts.length;
  }

  get hiddenSelectedCrafts(): ActiveCrafts[] {
    const selected: ActiveCrafts[] = (this.SelectedCrafts.value || [])
      .filter((item: ActiveCrafts | string) => item && typeof item !== 'string');
    return selected.filter(item => !this.filteredCrafts.includes(item));
  }
  
  filterDrivers() {
    if (!this.searchDriver) {
      this.filteredDrivers = [...this.Drivers];
      return;
    }

    this.filteredDrivers = this.Drivers.filter(driver =>
      driver.fullName.toLowerCase().includes(this.searchDriver.toLowerCase())
    );
  }

  onDriverSelectionChange() {
    const selectedValues = this.SelectedDrivers.value || [];
    if (selectedValues.includes(this.ALL_DRIVERS_VALUE)) {
      const selectedDrivers = selectedValues.filter((item: ActiveDriver | string) => item && typeof item !== 'string');
      const areAllDriversSelected = this.Drivers.length > 0 && selectedDrivers.length === this.Drivers.length;

      this.SelectedDrivers.setValue(areAllDriversSelected ? [] : [...this.Drivers], { emitEvent: false });
    }
    this.filterDrivers();
  }

  onDriverPanelToggle(opened: boolean) {
    if (!opened) {
      this.searchDriver = '';
      this.filteredDrivers = [...this.Drivers];
    }
  }

  getSelectedDriverCount(): number {
    const selectedValues = this.SelectedDrivers.value || [];
    return selectedValues.filter((item: ActiveDriver | string) => item && typeof item !== 'string').length;
  }

  getFirstSelectedDriver(): ActiveDriver | null {
    return (this.SelectedDrivers.value || []).find((item: any) => item && typeof item !== 'string') || null;
  }

  isAllDriversSelected(): boolean {
    return this.Drivers.length > 0 && this.getSelectedDriverCount() === this.Drivers.length;
  }

  isDriversIndeterminate(): boolean {
    const count = this.getSelectedDriverCount();
    return count > 0 && count < this.Drivers.length;
  }

  get hiddenSelectedDrivers(): ActiveDriver[] {
    const selected: ActiveDriver[] = (this.SelectedDrivers.value || [])
      .filter((item: ActiveDriver | string) => item && typeof item !== 'string');
    return selected.filter(item => !this.filteredDrivers.includes(item));
  }

  sendMessage() {
    this.sending = true;
    let recipients: Recipients[] = [];

    if (this.SelectedDrivers.value != null) {
      this.SelectedDrivers.value
        .filter((item: ActiveDriver | string) => item && typeof item !== 'string')
        .map((item: ActiveDriver) => {
        recipients.push({ recipientType: 'Employee', recipientId: item.id });
      });
    }
    if (this.SelectedCrafts.value != null) {
      this.SelectedCrafts.value
        .filter((item: ActiveCrafts | string) => item && typeof item !== 'string')
        .map((item: ActiveCrafts) => {
        recipients.push({ recipientType: 'Craft', recipientId: item.id });
      });
    }

    if (recipients.length == 0) {
      this.snackbar.open('Please select at least one recipient', '', {
        duration: 5000,
      });
      this.sending = false;
      return;
    }

    var messageText = this.regForm.get('messageText').value;
    if (messageText == null || messageText == '') {
      this.snackbar.open('Please enter a message', '', {
        duration: 5000,
      });
      this.sending = false;
      return;
    }

    var message: CreateMessage = {
      messageText: messageText,
      senderId: 0,
      recipients: recipients,
    };

    this.messagingService.createMessage(message).subscribe(() => {
      this.router.navigate(['/messages']);
    });

  }
}
